import { GTM_ID, META_PIXEL_ID } from '../data/site'

type EventPayload = Record<string, string | number | boolean | undefined>

declare global {
  interface Window {
    dataLayer?: unknown[]
    fbq?: (...args: unknown[]) => void
    _fbq?: unknown
  }
}

const isPlaceholder = (id: string) => id.includes('X') || /^0+$/.test(id)

let initialized = false

export function initTracking(): void {
  if (initialized || typeof window === 'undefined') return
  initialized = true

  window.dataLayer = window.dataLayer || []

  if (!isPlaceholder(GTM_ID) && !document.getElementById('gtm-script')) {
    const script = document.createElement('script')
    script.id = 'gtm-script'
    script.async = true
    script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`
    window.dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' })
    document.head.appendChild(script)
  }

  if (!isPlaceholder(META_PIXEL_ID) && !document.getElementById('meta-pixel')) {
    const script = document.createElement('script')
    script.id = 'meta-pixel'
    script.innerHTML = `!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;
n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
fbq('init','${META_PIXEL_ID}');fbq('track','PageView');`
    document.head.appendChild(script)
  }
}

/** Envía el evento a dataLayer (GTM) y al Pixel de Meta. */
export function trackEvent(event: string, payload: EventPayload = {}): void {
  if (typeof window === 'undefined') return
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({ event, ...payload })

  if (typeof window.fbq === 'function') {
    if (event === 'lead_form_submit') {
      window.fbq('track', 'Lead', payload)
    } else if (event === 'whatsapp_click') {
      window.fbq('track', 'Contact', payload)
    } else {
      window.fbq('trackCustom', event, payload)
    }
  }
}

export const trackWhatsAppClick = (location: string, intent: string) =>
  trackEvent('whatsapp_click', { cta_location: location, cta_intent: intent })

export const trackPhoneClick = (location: string) => trackEvent('phone_click', { cta_location: location })

export const trackLeadSubmit = (payload: EventPayload) => trackEvent('lead_form_submit', payload)
